import { FC, PropsWithChildren } from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import { makeSxStyles } from "ui";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { merge } from "lodash";

export interface DashboardContentLayoutProps extends PropsWithChildren {
  loading?: boolean;
  flexedContainer?: boolean;
  backButtonText?: string;
  hasBottomPadding?: boolean;
  onBack?: () => void;
}

const DashboardContentLayout: FC<DashboardContentLayoutProps> = (props) => {
  const {
    children,
    loading,
    onBack,
    backButtonText,
    flexedContainer,
    hasBottomPadding = false,
  } = props;
  const styles = useStyles();

  if (loading) {
    return (
      <Box sx={styles.progressContainer}>
        {onBack && (
          <Button
            sx={styles.backButton}
            color="inherit"
            startIcon={<ArrowBackIcon sx={styles.arrowBack} />}
            onClick={onBack}
          >
            {backButtonText || "Back"}
          </Button>
        )}
        <CircularProgress sx={styles.progress} />
      </Box>
    );
  }

  return (
    <Box
      sx={merge(
        styles.container,
        flexedContainer && styles.flexedContainer,
        hasBottomPadding && styles.hasBottomPadding,
      )}
    >
      {onBack && (
        <Button
          sx={styles.backButton}
          color="inherit"
          startIcon={<ArrowBackIcon sx={styles.arrowBack} />}
          onClick={onBack}
        >
          {backButtonText || "Back"}
        </Button>
      )}
      {children}
    </Box>
  );
};

const useStyles = makeSxStyles(() => ({
  backButton: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    textTransform: "none",
    fontSize: "22px",
    px: "12px",
  },
  arrowBack: {
    width: "28px",
    height: "28px",
    mr: "10px",
  },
  container: {
    padding: "16px 16px 30px",
  },
  hasBottomPadding: {
    paddingBottom: "20px",
  },
  flexedContainer: {
    display: "flex",
    paddingRight: "0",
    overflowX: "hidden",
  },
  progressContainer: {
    padding: "10px 20px 30px",
    width: "100%",
  },
  progress: {
    marginTop: "40px",
  },
}));

export default DashboardContentLayout;
